// src/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';

const API_URL = 'https://rys-backend.onrender.com/api';
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

  // (ฟังก์ชันนี้จะทำงานครั้งแรกที่เว็บโหลด)
  useEffect(() => {
    try {
      // --- ▼▼▼ (แก้ไข 1) เปลี่ยน localStorage เป็น sessionStorage ▼▼▼ ---
      const token = sessionStorage.getItem('rys_access_token');
      const userData = JSON.parse(sessionStorage.getItem('rys_user_data'));
      // --- ▲▲▲ สิ้นสุดส่วนที่แก้ไข ▲▲▲ ---
      
      if (token && userData) {
        const decodedToken = jwtDecode(token);
        if (decodedToken.exp * 1000 > Date.now()) {
          setUser(userData);
          setIsAuthenticated(true);
        } else {
          // (Token หมดอายุ)
          // --- ▼▼▼ (แก้ไข 2) เปลี่ยน localStorage เป็น sessionStorage ▼▼▼ ---
          sessionStorage.removeItem('rys_access_token');
          sessionStorage.removeItem('rys_user_data');
          // --- ▲▲▲ สิ้นสุดส่วนที่แก้ไข ▲▲▲ ---
        }
      }
    } catch (e) {
      console.error("Error loading auth state", e);
    } finally {
      setLoading(false);
    }
  }, []);

  // (ฟังก์ชัน Login - ที่ยิง API จริง)
  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_URL}/login`, { username, password });
      const { access_token, user: userData } = response.data;

      // --- ▼▼▼ (แก้ไข 3) เปลี่ยน localStorage เป็น sessionStorage ▼▼▼ ---
      sessionStorage.setItem('rys_access_token', access_token);
      sessionStorage.setItem('rys_user_data', JSON.stringify(userData));
      // --- ▲▲▲ สิ้นสุดส่วนที่แก้ไข ▲▲▲ ---

      setUser(userData);
      setIsAuthenticated(true);
      toast.success('เข้าสู่ระบบสำเร็จ!');
      return userData; // (คืนค่า "ข้อมูล User" กลับไป)

    } catch (err) {
      toast.error(err.response?.data?.message || "เข้าสู่ระบบไม่สำเร็จ");
      return null; // (คืนค่า "null" เมื่อล้มเหลว)
    }
  };

  // (ฟังก์ชัน Logout)
  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    // --- ▼▼▼ (แก้ไข 4) เปลี่ยน localStorage เป็น sessionStorage ▼▼▼ ---
    sessionStorage.removeItem('rys_access_token');
    sessionStorage.removeItem('rys_user_data');
    // --- ▲▲▲ สิ้นสุดส่วนที่แก้ไข ▲▲▲ ---
    toast.success('ออกจากระบบแล้ว');
  };

  // (ฟังก์ชัน getAuthHeaders ที่ถูกต้อง ที่เดียว)
  const getAuthHeaders = () => {
    // --- ▼▼▼ (แก้ไข 5) เปลี่ยน localStorage เป็น sessionStorage ▼▼▼ ---
    const token = sessionStorage.getItem('rys_access_token');
    // --- ▲▲▲ สิ้นสุดส่วนที่แก้ไข ▲▲▲ ---
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    getAuthHeaders 
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

// (Hook ที่ไฟล์อื่นเรียกใช้)
export const useAuth = () => {
  return useContext(AuthContext);
};